__turbopack_context__.v({
  "image": "origin-view-module__a2JqlG__image",
});
